import React, { useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import './prompt.scss'

export const Prompt = ({autoClose, content, header, onAutoClose, onPrimaryAction, onSecondaryAction, primaryAction, secondaryAction}) => {
	const [timer, setTimer] = useState(null);
	useEffect(() => {
		setTimeout(() => {
			if (autoClose) {
				const newVal = timer !== null ? timer - 1000 : autoClose;
				if (newVal <= 0) {
					onAutoClose && onAutoClose();
				}
				setTimer(newVal);
			}
		}, 1000);
	}, [autoClose, onAutoClose, timer, setTimer]);

	const renderPrompt = () => {
		if (autoClose && timer === null) {
			return null;
		}
		const promptContent = content.replace(/\{\{(timer)\}\}/g, timer/1000);
		return (
			<>
			<div className="prompt">
				<h1>{header ? header : `Emergency Dispatch From PMA Gunnerfeldt!`}</h1>
				<p>{promptContent}</p>
				{secondaryAction && onSecondaryAction &&
					<button className="secondary" onClick={onSecondaryAction}>{secondaryAction}</button>
				}
				{primaryAction && onPrimaryAction &&
					<button className="primary" onClick={onPrimaryAction}>{primaryAction}</button>
				}
			</div>
			<div className="prompt-mask"></div>
			</>
		);
	};

	return renderPrompt();
};

Prompt.propTypes = {
	autoClose: PropTypes.number,
	content: PropTypes.string,
	onAutoClose: PropTypes.func,
	onPrimaryAction: PropTypes.func,
	onSecondaryAction: PropTypes.func,
	primaryAction: PropTypes.string,
	secondaryAction: PropTypes.string
}

export default Prompt;
